import { useEffect, useState } from 'react';
import TimedNotice from '../timedNotice.js';
import { loadPersistedKey, savePersistedKey } from '../secureStore.js';
import { isHostedSite } from '../../llm/hosted.js';

const INTRO_COPY =
  'Create a place, choose a time and populate it with characters. The world keeps advancing while you watch and while you sleep. History remains after you leave. Generated suggestions are always editable.';

export default function WelcomeIntroStep(props: {
  onOpenSetup: () => void;
  onKeySaved: () => void;
}): JSX.Element {
  const [keyInput, setKeyInput] = useState('');
  const [configured, setConfigured] = useState(false);
  const [keyStatus, setKeyStatus] = useState<string | null>(null);
  const hosted = isHostedSite();

  useEffect(() => {
    let cancelled = false;
    void loadPersistedKey('deepseek').then((k) => {
      if (cancelled) return;
      setConfigured(k.trim().length > 0);
    });
    return () => { cancelled = true; };
  }, []);

  async function saveKey(): Promise<void> {
    const trimmed = keyInput.trim();
    if (!trimmed) {
      setKeyStatus('Enter a non-empty key or open Setup.');
      return;
    }
    if (configured) {
      const ok = window.confirm('Replace your saved DeepSeek key?');
      if (!ok) return;
    }
    await savePersistedKey('deepseek', trimmed);
    setConfigured(true);
    setKeyInput('');
    setKeyStatus('Key saved.');
    props.onKeySaved();
  }

  return (
    <div className="world-intro-copy">
      <p>{hosted ? INTRO_COPY : `${INTRO_COPY} API key required — Please go to setup first or enter in your api key here.`}</p>
      <div className="world-intro-key-row">
        <div className="world-intro-provider">
          Provider: <strong>DeepSeek</strong> · Model: <strong>deepseek-flash</strong>
        </div>
        {!hosted && (
          <>
            <label htmlFor="intro-api-key">DeepSeek API key</label>
            <input
              id="intro-api-key"
              type="password"
              value={keyInput}
              placeholder={configured ? 'Key configured — enter to replace' : 'sk-…'}
              onChange={(e) => setKeyInput(e.target.value)}
              autoComplete="off"
            />
            <div className="world-intro-actions">
              <button type="button" className="btn-primary" onClick={() => void saveKey()}>Save</button>
              <button type="button" className="btn-ghost" onClick={props.onOpenSetup}>Setup</button>
            </div>
            <TimedNotice text={keyStatus} className="hint" role="status" />
          </>
        )}
      </div>
    </div>
  );
}
